import { ReactComponent as Logo } from '../../logo.svg';

export const AppHeader = () => {
  return (
    <div className="h-16 p-2 bg-darkblue_100 rounded-br-lg shadow shadow-darkblue_40">
      <Logo className="h-12 w-12" />
    </div>
  );
};
